export default "__VITE_ASSET__Cqq2orNR__"